import TableHasPagenation from '../../../components/TableHasPagenation'
import { Table, Tooltip } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import EditableCell from '../../../components/EditTableCell'
import EditableRow from '../../../components/EditableRow'
const maxCount = 999999999
const components = {
  body: {
    row: EditableRow,
    cell: EditableCell
  }
}
const styleDiffMap = {
  0: {
    color: ' #FA4B54'
  },
  1: {
    color: '#006F5B'
  }
}
export default function ProductTransfersList({
  operateColums = [],
  tableColums = [],
  page = false,
  pageData = {},
  getList = () => {},
  editDataIndex = '',
  handleSave = () => {},
  edit = false,
  list = [], unit='unit'

}) {
  const Columns = [
    {
      title: '商品信息',
      dataIndex: 'productName',
      render: (text, record) => {
        return (
          <div style={{ fontSize: 12 }}>
            <div style={{ color: '#1890ff' }}>{record.name || record.productName}</div>
            <div>商品编码：{record.skuId}</div>
            <div>商品条码：{record.barcode}</div>
          </div>
        )
      }
    },
    {
      title: '商品类别',
      dataIndex: 'categoryName'
    },
    {
      title: '规格',
      dataIndex: 'specification'
    },
    {
      title: '单位',
      dataIndex: unit
    },
    {
      title: () => (
        <Tooltip title='移动平均价'>
          <div>
            <span style={{ marginRight: '6px' }}>成本价</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'costPrice'
    },
  ]
  let finalColumns = operateColums.length
    ? [...Columns, ...tableColums,  ...operateColums]
    : [...Columns, ...tableColums]
  const keyList = finalColumns.map(item => item.dataIndex)
  const editColumnIndex = keyList.indexOf(editDataIndex)
  if (editDataIndex) {
    finalColumns[editColumnIndex].onCell = record => {
      return {
        record,
        editable: true,
        dataIndex: finalColumns[editColumnIndex].dataIndex,
        title: finalColumns[editColumnIndex].title,
        handleSave: handleSave,
        inputFormatter: finalColumns[editColumnIndex].formatter
      }
    }
  }
  return page ? (
    <TableHasPagenation
      pageData={pageData}
      components={components}
      rowKey='id'
      onPageSizeChange={getList}
      columns={finalColumns}
    />
  ) : (
    <Table
      rowKey='id'
      columns={finalColumns}
      dataSource={list}
      pagination={null}
    />
  )
}
